import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { DogPark } from 'dogpark/routes/DogParkRoutes';
import { Travel } from 'leash/routes/LeashRoutes';
import { Pricing } from 'pricing/routes/PricingRoutes';
import { PupDocs } from 'pupdocs/routes/PupDocsRoutes';
import { Dashboard } from 'shared/pages/dashboard/Dashboard';

export function AuthenticatedRoutesHandler() {
  return (
    <Switch>
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/leash" component={Travel} />
      <Route path="/pupdocs" component={PupDocs} />
      <Route path="/pricing" component={Pricing} />
      <Route path="/dogpark" component={DogPark} />
      <Redirect from="/" exact to="/dashboard" />
      <Redirect from="*" exact to="/dashboard" />
    </Switch>
  );
}
